import { isNetworkError } from "@/utils/typeGuards/isNetworkError";

// A transport failure while the browser reports no connection is connectivity noise, not an app error: no exception capture, and the user hears about their connection rather than the request. Pairs isNetworkError with navigator.onLine in one place so every capture site applies the same rule.
export const isOfflineNetworkError = (error: unknown): boolean =>
  typeof navigator !== "undefined" &&
  !navigator.onLine &&
  isNetworkError(error);
